var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipe-page"},[_c('navigation',{staticClass:"recipe-page__nav"}),_vm._v(" "),_c('mix-header',{staticClass:"recipe-page__header"}),_vm._v(" "),_c('recipe',{attrs:{"recipe":_vm.getProductFromURL}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d65cf28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RecipesPage.vue
// module id = null
// module chunks = 